import { createTheme } from "@mui/material/styles";

// Material UI theme documentation: https://mui.com/material-ui/customization/theming/

const theme = createTheme({
  palette: {
    primary: {
      main: "#20314B",
    }
}});

export { theme };